import gql from 'graphql-tag';
import { PageInfoFragment, TransferOrderFragment } from '@/apolloConst/fragments';

const Orders = gql`
  query Orders(
    $number: [String!],
    $status: [TransferOrderStatus!],
    $startDate: String = "",
    $endDate: String = "",
    $pageNo: Int = 1,
    $maxResultsPerPage: Int = 25,
    $field: TransferOrderSortingField = createdAt,
    $direction: DirectionOfOrdering = desc,
    $locale: Locale!,
    $orderDetails: Boolean = false,
    $cancellationDate: Int!
    $classes: [String!],
    $isPast: Boolean = false,
  ) {
    transferOrders(
      filter: {
        numbers: $number
        status: $status
        startDate: {
          min: $startDate
          max: $endDate
        }
        inArchive: false
        class: {
          codes: $classes
        }
      }
      page: {
        pageNo: $pageNo
        maxResultsPerPage: $maxResultsPerPage
      }
      sorting: [
        {
          field: $field
          direction: $direction
        }
      ]
    ) {
      pageInfo {
        ...PageInfoFragment
      }
      results {
        ...TransferOrderFragment
        createdAt
        prepayType
        prepayMethod
        currency {
          code
        }
        prepayCurrency {
          code
        }
        passengers {
          name
        }
        country {
          code
        }
        prepayAmount: prepayAmountPure
        cashToDriver
        status
        totalCost: totalCost
        contract {
          cancellationTimeMin,
          cancellationPenaltyAmount(cancellationDate: $cancellationDate),
          isUrgent
        }
        returnTransferOrder:roundtripOrder {
          id
          number
        }
        additionalServiceItems {
          serviceId:additionalServiceId,
          code:additionalServiceCode
          cost
        }
        claims @include (if: $isPast) {
          status
          decree {
            type
            transactions {
              amount
              target
              type
              status
              currency {
                code
              }
            }
          }
        }
        extraPayments(filter: {statuses: [paid]}) {
          amount
          moneybackAmount
          currency {
            code
          }
        }
        awaitingConfirmationCash
      }
    }
  }
  ${PageInfoFragment}
  ${TransferOrderFragment}
`;

export const ReturnTransfers = gql`
query ReturnTransfers(
  $placeFrom: [ID!]
  $placeTo: [ID!]
  $class: [ID!]
) {
  transfers(
    page: {
      maxResultsPerPage: 40
    },
    filter: {
      placeFrom: {
        contains: {
          ids: $placeFrom
        }
      },
      placeTo: {
        contains: {
          ids: $placeTo
        }
      },
      options: {
        class: {
          ids: $class
        }
      }
    }
  ) {
    pageInfo {
      count
      resultsInPage
    }
    results {
      options {
        id
        transfer {
          placeFrom {
            id
            country {
              id
              code
            }
          }
          placeTo {
            id
            country {
              id
              code
            }
          }
        }
        class {
          id
          code
        }
      }
    }
  }
}
`;

export default Orders;



// WEBPACK FOOTER //
// ./src/views/BookingList/graphql/Orders.js